module.exports = __webpack_public_path__ + "img/product_kr.3ff69129.png";